export const formatDateElement = (data) => {
  const date = new Date(data);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // Ensures 3-letter month
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatDateTimeView = (input) => {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const formatted = `${day} ${month} ${year} ${
    hours === "23" && minutes === "59" ? "24:00" : `${hours}:${minutes}`
  }`;
  return formatted;
};

export const dateTimeSeperate = (dateTime) => {
  // Split method
  const [datePart, timePart] = dateTime.split("T");
  const timeHHMM = timePart.slice(0, 5); // "00:00"

  // Using Date object (local time)
  const d = new Date(dateTime);
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return { date: datePart, time: `${hours}:${minutes}` };
};

//hyphen separated
export const formatDateType = (data) => {
  const date = new Date(data);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

export const formatDateElementReverse = (date) => {
  if (!date) return null;

  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const calculateTotalHours = (startTime, endTime) => {
  if (!startTime || !endTime) return 0;
  const [startH, startM] = startTime.split(":").map(Number);
  const [endH, endM] = endTime.split(":").map(Number);

  // Convert both to minutes
  const startTotal = startH * 60 + startM;
  let endTotal = endH * 60 + endM;

  // Handle next-day case
  if (endTotal < startTotal) {
    endTotal += 24 * 60;
  }

  const diffMinutes = endTotal - startTotal;
  return diffMinutes / 60; // convert to hours
};

export const calculateTotalHoursSafe = (start, end, rtcChecked) => {
  if (!start || !end) return 0;
  if (rtcChecked && start === "00:00") return 24;

  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);

  const startMin = sh * 60 + sm;
  const endMin = eh * 60 + em;

  return Math.max(0, (endMin - startMin) / 60);
};

export function convertDate(dateStr) {
  // Map of month numbers to short names
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Split the input string by the hyphen
  // Example: "24-01-2026" becomes ["24", "01", "2026"]
  const [day, month, year] = dateStr.split("-");

  // Adjust month index (01 becomes 0, which is "Jan")
  const monthName = months[parseInt(month) - 1];

  // Return formatted string
  return `${day} ${monthName} ${year}`;
}
